<template>
  <CContainer class="pt-5" fluid>
    <Loading :active.sync="isLoading.validationTable"></Loading>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Edit MOU</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/notaris">
            <CIcon name="cil-balance-scale" />
            Notaris
          </b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'Notaris Edit', params: { notarisId: $route.params.notarisId } }">Edit</b-breadcrumb-item>
          <b-breadcrumb-item active>MOU</b-breadcrumb-item>
          <b-breadcrumb-item active>Edit</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CForm>
      <CRow class="mb-5">
        <CCol class="col-12 p-1">
          <CCard class="custom-form-card ml-2 mr-2">
            <CCardBody>
              <CRow>
                <CCol class="col-12 col-lg-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Tipe MoU"
                    label-for="modal-mou-type"
                    :state="formData.mouType.isValid"
                  >
                    <multiselect 
                      v-model="formData.mouType.value" 
                      :options="formData.mouType.options" 
                      :state="formData.mouType.isValid"
                      :class="{custom_multiselect_invalid: formData.mouType.isValid === false}"
                      :searchable="false"
                      id="modal-mou-type"
                      placeholder="Select an option"
                      :showLabels="false"
                      openDirection="bottom"
                      label="text"
                      track-by="value"
                      disabled
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                    </multiselect>
                  </b-form-group>
                </CCol>
                <CCol class="col-12 col-lg-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Office"
                    label-for="modal-mou-office"
                    :state="formData.officeCode.isValid"
                  >
                    <multiselect 
                      v-model="formData.officeCode.value" 
                      :options="formData.officeCode.options" 
                      :state="formData.officeCode.isValid"
                      :class="{custom_multiselect_invalid: formData.officeCode.isValid === false}"
                      id="modal-mou-office"
                      placeholder="Select an option"
                      :showLabels="false"
                      :loading="!formData.officeCode.isLoaded"
                      openDirection="bottom"
                      label="nameFull"
                      track-by="officeCode"
                      :internalSearch="false"
                      :preserveSearch="true"
                      @search-change="populateOffice"
                      disabled
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="noResult">No elements found.</template>
                      <template slot="afterList" v-if="formData.officeCode.currentPage < formData.officeCode.totalPages">
                        <div class="text-center custom-cursor-clickable p-2" @click="appendOffice" v-if="formData.officeCode.isLoaded">
                          <span class="text-muted">Load More</span>
                        </div>
                        <div class="text-center" v-else>
                          <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                        </div>
                      </template>
                    </multiselect>
                  </b-form-group>
                </CCol>
              </CRow>
              <CRow>
                <CCol class="col-12 col-lg-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Kode Notaris"
                    label-for="form-notary-code"
                    :state="formData.notaryCode.isValid"
                  >
                    <b-form-input
                      v-model="formData.notaryCode.value" 
                      maxlength="30"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                      :state="formData.notaryCode.isValid"
                      placeholder="Kode Notaris"
                      type="text"
                      disabled
                      id="form-notary-code"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Masa Berlaku MoU"
                    label-for="modal-mou-startDate"
                    :state="formData.startDate.isValid"
                  >
                    <b-input-group>
                      <b-form-datepicker
                        v-model="formData.startDate.value" 
                        :max="formData.startDate.maxValue"
                        id="modal-mou-startDate"
                        placeholder="DD/MM/YYYY"
                        :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                        locale="id"
                        :state="formData.startDate.isValid"
                        @context="onContextMouStartDate"
                      ></b-form-datepicker>
                      <b-input-group-append>
                        <b-input-group-text>
                          ~
                        </b-input-group-text>
                      </b-input-group-append>
                      <b-form-datepicker
                        v-model="formData.endDate.value" 
                        :min="formData.endDate.minValue"
                        :max="formData.endDate.maxValue"
                        id="modal-mou-endDate"
                        placeholder="DD/MM/YYYY"
                        :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                        locale="id"
                        :state="formData.endDate.isValid"
                        @context="onContextMouEndDate"
                      ></b-form-datepicker>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Tanggal Pembuatan MoU"
                    label-for="modal-mou-date"
                    :state="formData.mouDate.isValid"
                  >
                    <b-form-datepicker
                      v-model="formData.mouDate.value" 
                      id="modal-mou-date"
                      placeholder="DD/MM/YYYY"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      locale="id"
                      :state="formData.mouDate.isValid"
                    ></b-form-datepicker>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Deskripsi MoU"
                    label-for="modal-mou-description"
                    :state="formData.description.isValid"
                  >
                    <b-form-textarea
                      v-model="formData.description.value"
                      :state="formData.description.isValid"
                      maxlength="300"
                      placeholder="Deskripsi MoU"
                      id="modal-mou-description"
                      style="height: 12rem;"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Kuota Kontrak"
                    label-for="form-contract-quota"
                    :state="formData.contractQuota.isValid"
                  >
                    <b-form-input
                      :value="$helper.thousandSeparator(formData.contractQuota.value)"
                      @input="formData.contractQuota.value = $event.toString().replace(/\./g, '')"
                      maxlength="7"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                      :state="formData.contractQuota.isValid"
                      placeholder="Kuota Kontrak"
                      type="text"
                      id="form-contract-quota"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12 col-lg-6">
                  <b-form-group
                    :invalid-feedback="formData.vendorId.feedback"
                    valid-feedback="Vendor ID is available."
                    label="Vendor ID"
                    label-for="form-vendor-id"
                    :state="formData.vendorId.isValid"
                  >
                    <b-input-group>
                      <b-form-input
                        v-model="formData.vendorId.value"
                        :state="formData.vendorId.isValid"
                        placeholder="Vendor ID"
                        id="form-vendor-id"
                        @input="clearFormVendor"
                        maxlength="12"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          variant="primary"
                          :disabled="formData.vendorId.isValid"
                          :title="formData.vendorId.isValid ? 'ID already valid' : ''"
                          @click="validateVendorId"
                          style="width:4.5rem"
                        >
                          <b-spinner small v-if="formData.vendorId.isChecking" />
                          <span v-else>Check</span>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Vendor Name"
                    label-for="form-vendor-name"
                    :state="formData.vendorName.isValid"
                  >
                    <b-form-input
                      v-model="formData.vendorName.value"
                      :state="formData.vendorName.isValid"
                      placeholder="Vendor Name"
                      disabled
                      id="form-vendor-name"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Vendor Bank"
                    label-for="form-vendor-bank"
                    :state="formData.vendorBank.isValid"
                  >
                    <b-form-input
                      v-model="formData.vendorBank.value"
                      :state="formData.vendorBank.isValid"
                      placeholder="Vendor Bank"
                      disabled
                      id="form-vendor-bank"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Vendor Bank Account"
                    label-for="form-vendor-account"
                    :state="formData.vendorBankAccount.isValid"
                  >
                    <b-form-input
                      v-model="formData.vendorBankAccount.value"
                      :state="formData.vendorBankAccount.isValid"
                      placeholder="Vendor Bank Account"
                      disabled
                      id="form-vendor-account"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Vendor Bank Account Name"
                    label-for="form-vendor-accountName"
                    :state="formData.vendorBankName.isValid"
                  >
                    <b-form-input
                      v-model="formData.vendorBankName.value"
                      :state="formData.vendorBankName.isValid"
                      placeholder="Vendor Bank Account Name"
                      disabled
                      id="form-vendor-accountName"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Vendor Status"
                    label-for="form-vendor-status"
                    :state="formData.vendorStatus.isValid"
                  >
                    <b-form-input
                      v-model="formData.vendorStatus.value"
                      :state="formData.vendorStatus.isValid"
                      placeholder="Vendor Status"
                      disabled
                      id="form-vendor-status"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-table
                    striped
                    :items="formData.bussUnitTable.items"
                    :fields="formData.bussUnitTable.fields"
                  >
                    <template #cell(bussUnit)="row">
                      <b-form-group
                        invalid-feedback="This input is required."
                        :state="row.item.bussUnit.isValid"
                        class="mb-0"
                      >
                        <multiselect 
                          v-model="row.item.bussUnit.value" 
                          :options="bussUnitAvailOptions" 
                          :state="row.item.bussUnit.isValid"
                          :class="{custom_multiselect_invalid: row.item.bussUnit.isValid === false}"
                          placeholder="Select an option"
                          :showLabels="false"
                          openDirection="bottom"
                          label="text"
                          track-by="value"
                          :disabled="row.item.id != -1"
                          @input="onChangeBussUnit"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.value.bussUnit + " - " + (props.option.value.transType == "F" ? "Fiducia" : "Roya") }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                          <template slot="noResult">No elements found.</template>
                        </multiselect>
                      </b-form-group>
                    </template>
                    <template #cell(chargeAmount)="row">
                      <b-form-group
                        invalid-feedback="This input is required."
                        :state="row.item.chargeAmount.isValid"
                        class="mb-0"
                      >
                        <b-form-input
                          :value="$helper.thousandSeparator(row.item.chargeAmount.value)"
                          maxlength="19"
                          @input="row.item.chargeAmount.value = $event.toString().replace(/\./g, '')"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                          :state="row.item.chargeAmount.isValid"
                          placeholder="Charge Amount"
                          type="text"
                          class="custom-input-height"
                        ></b-form-input>
                      </b-form-group>
                    </template>
                    <template #cell(status)="row">
                      <b-form-group
                        invalid-feedback="This input is required."
                        :state="row.item.status.isValid"
                        class="mb-0"
                      >
                        <multiselect 
                          v-model="row.item.status.value" 
                          :options="row.item.status.options" 
                          :state="row.item.status.isValid"
                          :class="{custom_multiselect_invalid: row.item.status.isValid === false}"
                          :searchable="false"
                          placeholder="Select an option"
                          :showLabels="false"
                          openDirection="bottom"
                          label="text"
                          track-by="value"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                        </multiselect>
                      </b-form-group>
                    </template>
                    <template #cell(action)="row">
                      <b-button variant="danger" size="sm" title="Remove Row" @click="removeMouBussUnit(row.index)" v-if="isShowRemoveButton(row.item.id)"><CIcon name="cil-minus"/></b-button>
                    </template>
                    <template #head(action)>
                      <b-button variant="primary" size="sm" title="Add New Row" @click="addMouBussUnit"><CIcon name="cil-plus"/></b-button>
                    </template>
                  </b-table>
                </CCol>
              </CRow>
              <CRow class="mt-5 float-right">
                <CCol class="col-12">
                  <b-btn variant="secondary" class="mr-2" @click="$router.back()">Cancel</b-btn>
                  <b-btn variant="primary" type="submit" style="width:4rem" :disabled="isSubmitting" @click="saveMou">
                    <b-spinner small v-if="isSubmitting" />
                    <span v-else>Save</span>
                  </b-btn>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CForm>
    <b-modal
      v-model="modalConfirm.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      Vendor ID valid. Mohon simpan perubahan vendor ID dengan menekan tombol "Save" di bagian bawah kanan halaman ini.
      <CRow class="mt-3">
        <CCol class="col-12 text-center">
          <b-btn variant="secondary" class="mr-3" @click="modalConfirm.isShowing = false">Tutup</b-btn>
        </CCol>
      </CRow>
    </b-modal>
  </CContainer>
</template>


<script>
export default {
  name: 'MouAdd',
  data() {
    return {
      isLoading: {
        validationTable: false,
        validateContract: false
      },
      isSubmitting: false,
      mouNo: '',
      mouId: 0,
      // globally keeps track of available business unit options
      bussUnitAvailOptions: [],
      // combination of bussUnit and transType dropdown
      bussUnitTemplate: {
        value: '',
        isValid: null,
        isRequired: true,
        payloadKey: {
          bussUnit: "bussUnit",
          transType: "transType"
        }
      },
      chargeAmountTemplate: {
        value: '',
        isValid: null,
        isRequired: true,
        payloadKey: "chargeAmount"
      },
      bussUnitStatusTemplate: {
        value: '',
        isValid: null,
        isRequired: true,
        // hardcoded options
        options: [
          { value: "AC", text: "Aktif" },
          { value: "NA", text: "Nonaktif" }
        ],
        payloadKey: "status"
      },

      modalConfirm: {
        isShowing: false
      },
      
      formData: {

        description: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "description"
        },
        notaryCode: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "notaryCode"
        },
        startDate: {
          value: '',
          isValid: null,
          isRequired: true,
          maxValue: '',
          payloadKey: "startDate"
        },
        endDate: {
          value: '',
          isValid: null,
          isRequired: true,
          minValue: '',
          maxValue: '',
          payloadKey: "endDate"
        },
        mouDate: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "mouDate"
        },
        mouType: {
          value: '',
          isValid: null,
          isRequired: true,
          // hardcoded options
          options: [
            { value: 'I', text: "Individu" },
            { value: 'C', text: "Perusahaan" }
          ],
          payloadKey: "mouType"
        },
        officeCode: {
          /*
            "nameFull": "string",
            "nameShort": "string",
            "officeCode": "string
          */
          value: '',
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
          payloadKey: "officeCode"
        },
        status: {
          value: 'NA',
          payloadKey: "status"
        },

        vendorId: {
          value: '',
          isChecking: false,
          isValid: null,
          isRequired: true,
          feedback: 'Vendor ID is not valid.',
          payloadKey: "vendorId"
        },
        vendorName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorName"
        },
        vendorBank: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorBank"
        },
        vendorBankAccount: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorBankAccount"
        },
        vendorBankName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorBankName"
        },
        vendorStatus: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorStatus"
        },
        contractQuota: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "contractQuota"
        },

        bussUnitTable: {
          fields: [
            // bussUnit + transType
            {key: "bussUnit", label: "Business Unit"},
            {key: "chargeAmount", label: "Charge Amount"},
            {key: "status", label: "Status"},
            {key: "action", label: "Aksi"}
          ],
          items: [],
          sortBy: null,
          sortDesc: true,
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0
        },
      },
    }
  },
  methods: {
    onContextMouStartDate() {
      this.formData.endDate.minValue = this.formData.startDate.value
    },
    onContextMouEndDate() {
      this.formData.startDate.maxValue = this.formData.endDate.value
    },
    // check and disable all selected options from list
    onChangeBussUnit(){
      // enable all options
      for(let i = 0; i < this.bussUnitAvailOptions.length; i++){
        this.bussUnitAvailOptions[i].$isDisabled = false
      }
      // disable all already-selected options
      for(let i = 0; i < this.bussUnitAvailOptions.length; i++){
        for(let j = 0; j < this.formData.bussUnitTable.items.length; j++){
          // if business unit in row is not empty
          if(!this.$helper.isEmpty(this.formData.bussUnitTable.items[j].bussUnit.value)){
            // if current option is already selected in a row
            if(this.bussUnitAvailOptions[i].value.bussUnit == this.formData.bussUnitTable.items[j].bussUnit.value.value.bussUnit && this.bussUnitAvailOptions[i].value.transType == this.formData.bussUnitTable.items[j].bussUnit.value.value.transType){
              // disable already selected option
              this.bussUnitAvailOptions[i].$isDisabled = true
            }
          }
        }
      }
    },
    initialSetup(){
      this.mouId = this.$route.params.mouId
      let getUrl = "/mou/getOneById"

      let params = {
        mouId: this.mouId
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.formData.vendorId.isChecking = true
        // use index to properly update table row after manipulation
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.initData()
            this.formData.startDate.value = response.data.data.startDate
            this.formData.endDate.value = response.data.data.endDate
            this.formData.mouDate.value = response.data.data.mouDate
            this.formData.description.value = response.data.data.description
            this.formData.status.value = response.data.data.status
            this.formData.contractQuota.value = response.data.data.contractQuota
            this.formData.notaryCode.value = response.data.data.notaryCode
            this.formData.vendorId.value = response.data.data.vendorId
            this.formData.vendorId.isValid = true
            this.formData.vendorId.isChecking = false
            this.formData.vendorId.value = response.data.data.vendorId
            this.formData.vendorName.value = response.data.data.vendorName
            this.formData.vendorBank.value = response.data.data.vendorBank
            this.formData.vendorBankAccount.value = response.data.data.vendorBankAccount
            this.formData.vendorBankName.value = response.data.data.vendorBankName
            this.formData.vendorStatus.value = response.data.data.vendorStatus
            // this.validateVendorId()

            // find and assign proper value from all available options
            for(let i = 0; i < this.formData.mouType.options.length; i++){
              if(this.formData.mouType.options[i].value == response.data.data["mouType"]){
                this.formData.mouType.value = this.formData.mouType.options[i]
                break
              }
            }
            let found = false
            for(let i = 0; i < this.formData.officeCode.options.length; i++){
              if(this.formData.officeCode.options[i].officeCode == response.data.data["officeCode"]){
                this.formData.officeCode.value = this.formData.officeCode.options[i]
                found = true
                break
              }
            }
            if (!found) {
              this.formData.officeCode.value = { officeCode: response.data.data["officeCode"], nameShort: response.data.data["officeName"], nameFull: response.data.data["officeName"] }
            }
            // assign table
            for(let i = 0; i < response.data.data["mouDetails"].length; i++){
              this.addInitialMouBussUnit()
              this.formData.bussUnitTable.items[i].id = response.data.data["mouDetails"][i].id
              this.formData.bussUnitTable.items[i].chargeAmount.value = response.data.data["mouDetails"][i].chargeAmount
              // find and assign proper value from all available options
              for(let j = 0; j < this.bussUnitAvailOptions.length; j++){
                if(this.bussUnitAvailOptions[j].value.bussUnit == response.data.data["mouDetails"][i].bussUnit && this.bussUnitAvailOptions[j].value.transType == response.data.data["mouDetails"][i].transType){
                  this.formData.bussUnitTable.items[i].bussUnit.value = {
                    value: {
                      bussUnit: this.bussUnitAvailOptions[j].value.bussUnit,
                      transType: this.bussUnitAvailOptions[j].value.transType
                    },
                    text: this.bussUnitAvailOptions[j].text
                  }
                  this.bussUnitAvailOptions[j].$isDisabled = true
                  break
                }
              }
              for(let j = 0; j < this.formData.bussUnitTable.items[i].status.options.length; j++){
                if(this.formData.bussUnitTable.items[i].status.options[j].value == response.data.data["mouDetails"][i].status){
                  this.formData.bussUnitTable.items[i].status.value = {
                    value: this.formData.bussUnitTable.items[i].status.options[j].value,
                    text: this.formData.bussUnitTable.items[i].status.options[j].text
                  }
                }
              }
              // for(let j = 0; j < this.formData.officeCode.options.length; j++){
              //   if(this.formData.officeCode.options[j].officeCode == response.data.data["officeCode"]){
              //     this.formData.officeCode.value = this.formData.officeCode.options[j]
              //     break
              //   }
              // }
            }
          }
          else{
            this.$helper.toastError(this, "Get Detail MoU Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Get Detail MoU Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Get Detail MoU Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // validate vendor ID button functionality
    async validateVendorId() {
      let postUrl = '/mou/checkVendorId'
      let payload = new FormData()
      payload.append("vendorId", this.formData.vendorId.value)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.formData.vendorId.isChecking = true
        await this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.formData.vendorId.isValid = true
            this.formData.vendorName.value = response.data.data.namaVendor
            this.formData.vendorBank.value = response.data.data.bank
            this.formData.vendorBankAccount.value = response.data.data.noRek
            this.formData.vendorBankName.value = response.data.data.namaRek
            this.formData.vendorStatus.value = response.data.data.statusRek
            this.modalConfirm.isShowing = true
          }
          else{
            this.formData.vendorId.feedback = "Vendor ID tidak valid! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error")
            this.formData.vendorId.isValid = false
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.formData.vendorId.feedback = "Vendor ID tidak valid! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found")
          }
          else{
            this.formData.vendorId.feedback = "Vendor ID tidak valid! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error")
          }
          this.formData.vendorId.isValid = false
        })
        .finally(() => {
          this.formData.vendorId.isChecking = false
        })
      }
      else {
        this.formData.vendorId.feedback = "Access Denied!"
        this.formData.vendorId.isValid = false
      }
    },
    // clear vendor inputs on vendor ID change
    clearFormVendor() {
      this.formData.vendorId.isValid = null
      this.formData.vendorName.value = ''
      this.formData.vendorBank.value = ''
      this.formData.vendorBankAccount.value = ''
      this.formData.vendorBankName.value = ''
      this.formData.vendorStatus.value = ''
    },
    // clear skb date form on selecting no skb
    // clearSkbDate(){
    //   this.formData.skbValidFrom.value = ''
    //   this.formData.skbValidTo.value = ''
    //   this.formData.skbValidFrom.isValid = null
    //   this.formData.skbValidTo.isValid = null
    // },
    initData(){
      this.formData.description.value = ''
      this.formData.description.isValid = null
      this.formData.startDate.value = ''
      this.formData.startDate.isValid = null
      this.formData.endDate.value = ''
      this.formData.endDate.isValid = null
      this.formData.mouDate.value = ''
      this.formData.mouDate.isValid = null
      this.formData.mouType.value = ''
      this.formData.mouType.isValid = null
      this.formData.officeCode.value = ''
      this.formData.officeCode.isValid = null
      this.formData.bussUnitTable.items = []
      for(let i = 0; i < this.bussUnitAvailOptions.length; i++){
        this.bussUnitAvailOptions[i].$isDisabled = false
      }
    },
    removeMouBussUnit(idx) {
      this.formData.bussUnitTable.items.splice(idx, 1)
      this.onChangeBussUnit()
    },
    addInitialMouBussUnit() {
      this.formData.bussUnitTable.items.push({
        "id": -1,
        "bussUnit": this.$lodash.cloneDeep(this.bussUnitTemplate),
        "chargeAmount": this.$lodash.cloneDeep(this.chargeAmountTemplate),
        "status": this.$lodash.cloneDeep(this.bussUnitStatusTemplate)
      })
    },
    addMouBussUnit() {
      this.formData.bussUnitTable.items.unshift({
        "id": -1,
        "bussUnit": this.$lodash.cloneDeep(this.bussUnitTemplate),
        "chargeAmount": this.$lodash.cloneDeep(this.chargeAmountTemplate),
        "status": this.$lodash.cloneDeep(this.bussUnitStatusTemplate)
      })
    },
    async populateOffice(query = "") {
      this.formData.officeCode.isLoaded = false
      this.formData.officeCode.totalPages = 0
      this.formData.officeCode.totalRows = 0
      this.formData.officeCode.currentPage = 1
      this.formData.officeCode.lastQuery = query
      // URL builder
      let getUrl = "/office/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.officeCode.currentPage - 1, this.formData.officeCode.perPage)
      if(query !== ""){
        params['filterType'] = "nameFull"
        params['filterValue'] = query
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        await this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.formData.officeCode.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.formData.officeCode.options.push(response.data.data.data[i])
            }
            this.formData.officeCode.totalRows = response.data.data.totalElements
            this.formData.officeCode.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.officeCode.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // load more options for modal office dropdown dynamically
    appendOffice() {
      this.formData.officeCode.isLoaded = false
      // URL builder
      let getUrl = "/office/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.officeCode.currentPage, this.formData.officeCode.perPage)
      if(this.formData.officeCode.lastQuery !== ""){
        params['filterType'] = "nameFull"
        params['filterValue'] = this.formData.officeCode.lastQuery
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.formData.officeCode.options.push(response.data.data.data[i])
            }
            this.formData.officeCode.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.officeCode.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // get all, no pagination
    async populateBussUnit() {
      // URL builder
      let getUrl = "/bussUnit/getAll"
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        await this.$axios.get(getUrl).then(response => {
          if(response.status == 200){
            this.bussUnitAvailOptions = []
            for(let i = 0; i < response.data.data.length; i++){
              this.bussUnitAvailOptions.push({
                "value": {
                  "bussUnit": response.data.data[i].bussUnit,
                  "transType": "F"
                },
                "text": response.data.data[i].bussUnit + " " + response.data.data[i].bussUnitDesc + " (Fiducia)"
              })
              this.bussUnitAvailOptions.push({
                "value": {
                  "bussUnit": response.data.data[i].bussUnit,
                  "transType": "R"
                },
                "text": response.data.data[i].bussUnit + " " + response.data.data[i].bussUnitDesc + " (Roya)"
              })
            }
          }
          else{
            this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    saveMou(event) {
      event.preventDefault()
      // validate form entries before submit
      let isFormValid = true
      let obj = {}
      for(const [key, data] of Object.entries(this.formData)){
        // skip unused properties
        if(key == "isSubmitting" || key == "mouNo" || key == "bussUnitAvailOptions" || key == "bussUnitTemplate" || key == "chargeAmountTemplate" || key == "bussUnitStatusTemplate" || key == "notaryCode"){
          continue
        }
        // check multiselect fields
        else if(key == "mouType"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        else if(key == "officeCode"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.officeCode
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // check and mirror MoU Date fields
        else if(key == "startDate" || key == "endDate"){
          if(!this.$helper.isEmpty(this.formData.startDate.value) && !this.$helper.isEmpty(this.formData.endDate.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
          else if(this.formData.startDate.isRequired || this.formData.endDate.isRequired){
            this.formData.startDate.isValid = false
            this.formData.endDate.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // check all Business Unit Table rows
        else if(key == "bussUnitTable"){
          let mouDetails = []
          for(let i = 0; i < data.items.length;i++){
            let mouDetail = {}
            for(const [key, row] of Object.entries(data.items[i])){
              if(key == "id"){
                // if editing, add id information
                if(!this.$helper.isEmpty(this.mouId)){
                  mouDetail["id"] = row
                }
              }
              else if(key == "bussUnit"){
                if(!this.$helper.isEmpty(row.value)){
                  row.isValid = null
                  mouDetail[row.payloadKey["bussUnit"]] = row.value.value.bussUnit
                  mouDetail[row.payloadKey["transType"]] = row.value.value.transType
                }
                else if(row.isRequired){
                  row.isValid = false
                  isFormValid = false
                }
                else{
                  row.isValid = null
                }
              }
              else if(key == "status"){
                if(!this.$helper.isEmpty(row.value)){
                  row.isValid = null
                  mouDetail[row.payloadKey] = row.value.value
                }
                else if(row.isRequired){
                  row.isValid = false
                  isFormValid = false
                }
                else{
                  row.isValid = null
                }
              }
              else{
                if(!this.$helper.isEmpty(row.value)){
                  row.isValid = null
                  mouDetail[row.payloadKey] = row.value
                }
                else if(row.isRequired){
                  row.isValid = false
                  isFormValid = false
                }
                else{
                  row.isValid = null
                }
              }
            }
            mouDetails.push(mouDetail)
          }
          obj["mouDetails"] = mouDetails
        }
        // check remaining fields
        else{
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = ''
        // if editing
        if(!this.$helper.isEmpty(this.mouId)){
          obj["mouId"] = this.mouId
          obj["notaryId"] = this.$route.params.notarisId
          postUrl = '/mou/edit'
        }
        // if adding
        else{
          obj["status"] = "NA"
          obj["notaryId"] = this.$route.params.notarisId
          postUrl = '/mou/add'
        }

        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
        this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              // this.$helper.toastSuccess(this, (this.$helper.isEmpty(this.mouId) ? "Add MoU Berhasil! Mohon melakukan Aktivasi MoU terlebih dahulu melalui tabel Data Mou." : "Edit MoU Berhasil!"))

              this.$store.commit('set', ['toast', true])
              this.$store.commit('set', ['toastMsg', "Edit MOU Berhasil! " + (response.data.reason ? response.data.reason : "")])
              this.$router.push({ name: 'Notaris Edit', params: { notarisId: this.$route.params.notarisId }  });
            }
            else{
              this.$helper.toastError(this, (this.$helper.isEmpty(this.mouId) ? "Add MoU Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, (this.$helper.isEmpty(this.mouId) ? "Add MoU Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, (this.$helper.isEmpty(this.mouId) ? "Add MoU Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    isShowRemoveButton(rowId) {
      // if last table item, do not remove
      if(this.formData.bussUnitTable.items.length <= 1) return false
      // if currently editing
      if(!this.$helper.isEmpty(this.mouId)) {
        // if row already exists
        if(rowId !== -1){
          return false
        }
      }
      return true
    }
  },
  computed: {
  },
  async mounted() {
    this.populateOffice().then(() => {
      this.populateBussUnit().then(() => {
        this.initialSetup()
      })
    })
    // get all available business unit selection
  },
  created(){
  }
}
</script>

<style>

</style>
